var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 679.1 435.4",
    style: {
      enableBackground: "new 0 0 679.1 435.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#FFFFFF;}\r\n\t.st2{fill:#D3AF4A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -300.5,
    y: -182.3,
    className: "st1",
    width: 1280,
    height: 800
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "339.6,73.4 339.6,73.4 363.9,115.6 469.7,298.8 510.1,298.8 339.6,3.4 319.4,38.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "188.7,264.4 168.9,298.8 209.4,298.8 229.2,264.4  "
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "402.2,213.5 258.7,213.5 330.5,89.2 310.3,54.2 198,248.5 422.5,248.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.6,378.2H24l-6.5,14.3H2l34-75.8h15.6l34,75.8H70L63.6,378.2z M43.8,332.6l-14.1,32.3h28.1L43.8,332.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M162.6,392.5h-12.1l-9.4-23.8l-8-23.9l-7.9,24.1l-9.2,23.6h-12.1L76,316.7h16l17.9,54.7l18.4-54.7h9.3 l18.9,54.7l17.3-54.7h16L162.6,392.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.1,378.2h-39.6l-6.5,14.3h-15.5l34-75.8h15.6l34,75.8h-15.6L241.1,378.2z M221.3,332.6l-14.1,32.3h28.1 L221.3,332.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.9,348l20.1-31.3h17.2v0.6l-30.2,43.8v31.3h-14.3v-31.3l-29.1-43.8v-0.6h17L288.9,348z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,316.7v62.6h39v13.2h-53.3v-75.8H346.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,392.5v-75.8h14.2v75.8H396z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.7,392.8h-14.8l-31.5-76.1h16l22.8,59l22.9-59h16L464.7,392.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.1,392.5v-75.8h14.2v75.8H505.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.5,316.6h14.3v75.9h-8.9v0.1l-39.8-51.2v51.1h-14.3v-75.8h11.6l37.1,47V316.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.1,335.2c-5.1-4.9-12.7-7.6-19.3-7.6c-16.2,0-26.1,12.3-26.1,27.9c0,12.4,7.3,25.3,26.1,25.3c6,0,11.1-1.3,17.1-6.1 v-13.4h-19.4v-12.8h32.5v31.9c-7.5,8.6-16.9,13.6-30.2,13.6c-28.5,0-40-18.7-40-38.6c0-21.3,13.3-41,40-41 c10.2,0,20.3,3.9,28.1,11.6L666.1,335.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 339.1,
    y: 146.6,
    width: 20.4,
    height: 20.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.5,
    y: 146.6,
    width: 20.4,
    height: 20.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.5,
    y: 174.2,
    width: 20.4,
    height: 20.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.1,
    y: 174.2,
    width: 20.4,
    height: 20.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,433.4v-27.7h5.2l13,16.7L33,405.7h5.2v27.7h-6v-17.1c0-0.3,0-0.8,0.1-1.3s0.1-1.1,0.2-1.7c-0.3,0.7-0.7,1.3-0.9,1.8 c-0.3,0.5-0.5,0.8-0.7,1.1L20.4,430h-1.3L8.7,416.2c-0.4-0.5-0.7-1-1-1.5c-0.3-0.5-0.5-0.9-0.7-1.3c0.1,0.6,0.1,1.1,0.1,1.6 c0,0.5,0,0.9,0,1.4v17.1H2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,433.4l15.6-27.7h6.2l15.9,27.7h-7.2l-3.3-6H83.6l-3.2,6H74z M86.4,422.3h12.1l-6-11.2L86.4,422.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.2,433.4v-27.7h4.4L172,422c0.7,0.5,1.2,1,1.8,1.5c0.5,0.5,1,1,1.4,1.5c-0.1-1.6-0.2-2.7-0.2-3.3 c0-0.6-0.1-1.1-0.1-1.5v-14.5h5.8v27.7h-4.4L156,416.3c-0.5-0.4-0.9-0.8-1.3-1.2c-0.4-0.3-0.7-0.7-1-1.1c0.1,0.9,0.2,1.7,0.2,2.4 c0,0.8,0.1,1.4,0.1,2v14.9H148.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,433.4l15.6-27.7h6.2l15.9,27.7h-7.2l-3.3-6h-17.5l-3.2,6H217.1z M229.5,422.3h12.1l-6-11.2L229.5,422.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4,410.7h-20.1v17.5h20.1V422h-10.5v-4.7h16.8v9.5c0,2.5-0.5,4.3-1.4,5.2s-2.8,1.4-5.4,1.4h-19.1 c-2.7,0-4.5-0.5-5.4-1.4s-1.4-2.6-1.4-5.2v-14.6c0-2.5,0.5-4.2,1.4-5.2s2.8-1.4,5.4-1.4h19.1c2.7,0,4.5,0.5,5.4,1.4 c1,0.9,1.4,2.5,1.4,4.9v0.6l-6.3,1.1V410.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.9,433.4v-27.7h28.3v4.7h-21.9v6.2h12.8v4.7h-12.8v6.9h22.1v5.2H363.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9,433.4v-27.7h5.2l13,16.7l12.7-16.7h5.2v27.7h-6v-17.1c0-0.3,0-0.8,0.1-1.3s0.1-1.1,0.2-1.7 c-0.3,0.7-0.7,1.3-0.9,1.8c-0.3,0.5-0.5,0.8-0.7,1.1L450.3,430H449l-10.4-13.9c-0.4-0.5-0.7-1-1-1.5c-0.3-0.5-0.5-0.9-0.7-1.3 c0.1,0.6,0.1,1.1,0.1,1.6c0,0.5,0,0.9,0,1.4v17.1H431.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.2,433.4v-27.7h28.3v4.7h-21.9v6.2h12.8v4.7h-12.8v6.9h22.1v5.2H509.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.2,433.4v-27.7h4.4l19.5,16.3c0.7,0.5,1.2,1,1.8,1.5c0.5,0.5,1,1,1.4,1.5c-0.1-1.6-0.2-2.7-0.2-3.3 c0-0.6-0.1-1.1-0.1-1.5v-14.5h5.8v27.7h-4.4L585,416.3c-0.5-0.4-0.9-0.8-1.3-1.2c-0.4-0.3-0.7-0.7-1-1.1c0.1,0.9,0.2,1.7,0.2,2.4 c0,0.8,0.1,1.4,0.1,2v14.9H577.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.3,410.7v22.7h-6.4v-22.7h-12.7v-4.9h31.9v4.9H664.3z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c2f69101f6c6178de01507904d08f6a3.svg";
export { ForwardRef as ReactComponent };